import { FormCounterField, lt } from '@mews/framework';
import { Button, Stack } from '@optimus-web/core';
import { MAX_DAILY_SELL_LIMIT, MIN_DAILY_SELL_LIMIT } from '../constants';
import { fieldNames } from './schema';

interface FormContentProps {
    hasDailyLimit: boolean;
    hasDirtyFields: boolean;
    onRemove: () => void;
    submit: () => void;
}

export const FormContent = ({ hasDailyLimit, hasDirtyFields, onRemove, submit }: FormContentProps) => (
    <>
        <FormCounterField
            name={fieldNames.absolutePerTimeUnitLimit}
            label={lt('DailyLimit')}
            min={MIN_DAILY_SELL_LIMIT}
            max={MAX_DAILY_SELL_LIMIT}
        />
        <Stack distribution="space-between">
            <Button type="button" variant="tertiary" onClick={onRemove} disabled={!hasDailyLimit}>
                {lt('Remove')}
            </Button>
            <Button variant="primary" onClick={submit} disabled={hasDailyLimit && !hasDirtyFields} type="submit">
                {lt('Apply')}
            </Button>
        </Stack>
    </>
);
